var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.use_uuid)?_c('tenancies-find',{attrs:{"params":{
        tenancy: _vm.uuid
    },"include":['property']},on:{"success":_vm.found,"error":function($event){_vm.use_uuid = false}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var tenancy = ref.data;
    var is_loading = ref.is_loading;
return [_c('div',{staticClass:"input is-disabled",class:{
            'opacity-50': is_loading
        }},[_vm._v("\n        "+_vm._s(is_loading ? 'Loading...' : tenancy.property.name)+"\n    ")])]}}],null,false,4163730621)}):_c('algolia-get',{attrs:{"index":"tenancies","get-on-created":false},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var data = ref.data;
    var clear = ref.clear;
    var filterByQuery = ref.filterByQuery;
    var filterByBoolean = ref.filterByBoolean;
    var get = ref.get;
return [_c('with-variables',{attrs:{"variables":{
            search: function (query) {
                clear()
                filterByQuery(query)
                filterByBoolean('is_archived', false)
                get()
            }
        }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
        var search = ref.search;
return [_c('input-select',{attrs:{"value":_vm.value,"sid":_vm.sid,"name":_vm.name,"disabled":_vm.disabled,"options":_vm.transform(data),"can-search":true,"placeholder":"Select tenancy..."},on:{"input":function($event){return _vm.$emit('input', arguments[0])},"search":search,"open":search}})]}}],null,true)})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }